var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    fill: "#A1A9B2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12h8l-2.625-3.5L11 11 9.625 9.167Zm-1 3q-.625 0-1.062-.438Q5 14.125 5 13.5v-10q0-.625.438-1.062Q5.875 2 6.5 2h10q.625 0 1.062.438Q18 2.875 18 3.5v10q0 .625-.438 1.062Q17.125 15 16.5 15Zm0-1.5h10v-10h-10v10Zm-3 4.5q-.625 0-1.062-.438Q2 17.125 2 16.5V5h1.5v11.5H15V18Zm3-14.5v10-10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoGallery);
export default __webpack_public_path__ + "static/media/photo-gallery.45623e2d.svg";
export { ForwardRef as ReactComponent };